export default {
  SET_RANDOM_QUESTIONS_ID: (state, payload) => {
    state.currentGame.questionsIdList = payload;
  },

  SET_GROUP_INDEX: (state, payload) => {
    state.currentGame.groupIndex = payload;
  },

  START_GAME: (state) => {
    state.currentGame.gameStarted = true;
    state.currentGame.partialScore = 0;
    state.currentGame.partialScore = 0;
    state.currentGame.questionsIndex = 0;
    state.currentGame.gameEnded = false;
    state.currentGame.answerCorrect = false;
    state.currentGame.showNext = false;
  },

  END_GAME: (state) => {
    console.log('%c+', 'font-size: 1px; padding: 180px 320px; background: url(https://media.giphy.com/media/14xFtRMKKza7WU/source.gif); background-size: 100%; color: transparent;');
    state.currentGame.questionsIndex += 1;
    state.currentGame.gameEnded = true;
    state.currentGame.answerChecked = false;
    state.currentGame.showProgress = false;
  },

  CORRECT_ANSWER: (state) => {
    state.currentGame.partialScore += 1;
    state.currentGame.answerCorrect = true;
    state.currentGame.answerChecked = true;
  },

  WRONG_ANSWER: (state) => {
    state.currentGame.answerCorrect = false;
    state.currentGame.answerChecked = true;
  },

  INCREASE_QUESTIONS: (state) => {
    state.currentGame.questionsIndex += 1;
    state.currentGame.answerChecked = false;
    state.currentGame.answerCorrect = false;
    state.currentGame.showNext = false;
  },
};
